module.exports = __webpack_public_path__ + "img/lookbook_6_right.3165731d.png";